import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { logout } from "../../redux/features/loginSlice";
import { Home, ShoppingBag, MapPin, User, LogOut } from "lucide-react";
import { useTranslation } from "react-i18next";

function Sidebar() {
  const { t } = useTranslation()
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    dispatch(logout());
    setTimeout(() => {
      navigate("/");
    }, 500);
  };

  const menuItems = [
    { label: `${t("Dashboard")}`, path: "/dashboard", icon: <Home size={18} /> },
    { label: `${t("Orders")}`, path: "/order", icon: <ShoppingBag size={18} /> },
    { label: `${t("Address")}`, path: "/address", icon: <MapPin size={18} /> },
    { label: `${t("Account_Detail")}`, path: "/account", icon: <User size={18} /> },
  ];

  return (
    <aside className="card border-0 shadow-sm rounded-4 p-3 bg-white">
      <h5 className="border-bottom pb-2 mb-3 text-dark fw-semibold">
        {`${t('My_Account')}`}
      </h5>
      <ul className="list-unstyled m-0 p-0">
        {menuItems.map((item) => (
          <li key={item.path} className="mb-2">
            <Link
              to={item.path}
              className={`d-flex align-items-center gap-2 px-3 py-2 rounded-3 text-decoration-none transition-all
                ${isActive(item.path)
                  ? "text-white shadow-sm"
                  : "text-muted hover:bg-light"
                }`}
              style={{
                backgroundColor: isActive(item.path) ? "var(--secondary-light-color)" : "transparent",
                transition: "all 0.25s ease",
              }}
            >
              {item.icon}
              <span className="fw-medium">{item.label}</span>
            </Link>
          </li>
        ))}

        <li className="mt-3">
          <button
            onClick={handleLogout}
            className="d-flex align-items-center gap-2 w-100 px-3 py-2 rounded-3 border-0 bg-transparent text-danger fw-medium hover:bg-light transition-all"
            style={{
              cursor: "pointer",
              transition: "all 0.25s ease",
            }}
          >
            <LogOut size={18} />
            {`${t('Logout')}`}
          </button>
        </li>
      </ul>
    </aside>
  );
}

export default Sidebar;
